<template>
    <div class="form__wrapper">
        <div class="regirect">
            <div class="text">Don't have an account?</div>
            <router-link :to="{ name: 'registration' }">
                Create Account
            </router-link>
        </div>
        <div class="form__content">
            <form action="">
                <router-link :to="{ name: 'login' }" class="back">
                <svg width="20.000000" height="20.000000" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                        <clipPath id="clip326_21231">
                            <rect id="Arrows" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                        </clipPath>
                    </defs>
                    <rect id="Arrows" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                    <g clip-path="url(#clip326_21231)">
                        <path id="Vector" d="M12 15L7 10L12 5" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.300000" stroke-linejoin="round" stroke-linecap="square"/>
                    </g>
                </svg>
                </router-link>
                <div class="title">Forgot Password</div>
                <div class="desc">Enter the email address you signed up with below. An email will be sent containing a link to reset your password.</div>
                <InputWrapper>
                    <template #text>
                        email
                    </template>
                    <template #input>
                        <Input v-model:value="reset_data.email"></Input>
                    </template>
                </InputWrapper>
                <SubmitButton @click="resetPassword">Send Link</SubmitButton>
            </form>
        </div>

    </div>
    <StatusRequest ref="toast"></StatusRequest>
</template>

<script>
import InputWrapper from '../InputWrapper.vue';
import Input from '../Input.vue';
import RememberMeButton from '../RememberMeButton.vue';
import SubmitButton from '../SubmitButton.vue';
import SocialAuth from '../SocialAuth.vue';
import InputPasswordValodation from '../InputPasswordValodation.vue';
import InputPassword from '../InputPassword.vue';
import axios from "axios";
import StatusRequest from "@/components/UI/StatusRequest.vue";
    export default {
        components: {
            InputWrapper,
            Input,
            RememberMeButton,
            SubmitButton,
            SocialAuth,
            InputPasswordValodation,
            InputPassword,
            StatusRequest
        },
        data() {
            return {
            reset_data:{
                email: null,
            },
            request: false,
            }
        },
        methods: {
            resetPassword(e){
                e.preventDefault();
                if(this.request){
                    return false;
                }
                this.request = true;
                let fData = new FormData();
                fData.append("email",this.reset_data.email);
                axios.post("/forget-password",fData)
                    .then(resp => {
                        this.showMessage(true,"Successful");
                })
                .catch(error => this.showMessage(false,"This mailing address is not registered in the system."))
                .finally(this.request = false);

            },
            showMessage(type, title) {
            if (type) type = 'success';
            else type = "error";
            const toast = this.$refs.toast;
            toast.show(type, title, 5000);
            }
        },
    }
</script>
<style scoped>
.forgot__password{
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
}
.form__wrapper{
    padding: 24px 0;
    height: 100%;
}
.regirect{
    display: flex;
    justify-content: right;
    gap: 16px;
    align-items: center;
}
.regirect .text{
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    }
.regirect a{
    background: rgb(222, 230, 234);
    border-radius: 32px;
    padding: 10px 24px;

    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
.form__content{
    height: calc(100% - 14px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

}
.form__content .back{
position: absolute;
left: -64px;
top: 0;

background: rgb(222, 230, 234);
width: 32px;
height: 32px;
border-radius: 100%;
display: flex;
align-items: center;
justify-content: center;
}
form{
    width: 322px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
}
.form__content .desc{
    color: rgb(85, 98, 114);
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
.title{
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    padding-bottom: 1px;
}
@media (max-width: 768px) {
    .form__content .back{
        display: none;
    }
}
</style>